var angular = require('angular');
var ngModule = angular.module('/wheel/views/wheel.html', []);
ngModule.run(['$templateCache', function($templateCache) {
  $templateCache.put('/wheel/views/wheel.html',
    '<section class="panel ng-cloak">\n' +
    '    <div class="panel-body clearfix action-buttons">\n' +
    '        <h4 class="pull-left" ng-show="participants.length">\n' +
    '            {{ \'PARTICIPANTS\' | translate }}: {{ participants.length }} | {{ \'TOTAL\' | translate }}: {{ total }}\n' +
    '        </h4>\n' +
    '        <div class="pull-right">\n' +
    '            <button ng-disabled="disabled" class="btn btn-default" ng-click="resetRotation()">{{ \'PAGES.WHEEL.RESET\' | translate }}</button>\n' +
    '            <button ng-disabled="disabled" class="btn" ng-class="{\'btn-default\': !zoom, \'btn-primary\': zoom }" ng-click="zoom = !zoom" id="button-zoom">{{ \'PAGES.WHEEL.ZOOM\' | translate }}</button>\n' +
    '            <button ng-disabled="disabled" class="btn" ng-class="{\'btn-default\': !zoom || !zoom2x, \'btn-primary\': zoom && zoom2x }" ng-click="zoom2x = !zoom2x; zoom = true" id="button-zoom2x">{{ \'PAGES.WHEEL.ZOOM2\' | translate }}</button>\n' +
    '            <button ng-disabled="!winner" class="btn" ng-class="{\'btn-default\': !winner, \'btn-success\': !!winner }" ng-click="next()">{{ \'PAGES.WHEEL.NEXT\' | translate }}</button>\n' +
    '            <button ng-disabled="disabled || !!winner" ng-class="{\'btn-default\': disabled || !!winner, \'btn-success\': !(disabled || !!winner) }" class="btn" ng-click="tap()">{{ \'PAGES.WHEEL.GO\' | translate }}</button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '<div class="relative-wheel-container">\n' +
    '    <div class="wheel-container" hm-panend="panEnd($event)" hm-recognizer-options="[{\'type\':\'pan\',\'directions\':\'DIRECTION_HORIZONTAL\'}]" hm-tap="tap($event)" ng-mouseenter="resetTextRotation()">\n' +
    '        <div class="wheel" ng-class="{\'zoom\': zoom, \'zoom-2x\': zoom && zoom2x}"></div>\n' +
    '    </div>\n' +
    '    <div class="line"  ng-class="{\'zoom\': zoom, \'zoom-2x\': zoom && zoom2x}" ng-show="zoom"></div>\n' +
    '</div>\n' +
    '');
}]);

module.exports = "/wheel/views/wheel.html";